import React, { FC } from 'react';

export interface IPatientIdFormatterProps {
  id?: string;
}

export const patientIdFormatter: FC<IPatientIdFormatterProps> = ({ id }) => {
  if (!id?.length) {
    return <span className="table-cell-placeholder">-</span>;
  }

  return <span>{id}</span>;
};
